module.exports = __webpack_public_path__ + "img/Rimini_Peacock.cc030c21.png";